export enum HistoryResultRowsDesign {
    SELECTED_RESULT_BACKGROUND_COLOR = "rgb(0, 130, 212)",
    SELECTED_RESULT_TEXT_COLOR = "white",
    BORDER_LEFT_TEST_PASSED_COLOR = "3px solid #8DF279",
    BORDER_LEFT_TEST_NOT_PASSED_COLOR = "3px solid red",
    TEXT_ALIGN = "center"
}